<template>
<div>
  <b-row id="specialties" class="section py-lg-5 py-0 my-lg-5 my-0 reverse-sm">
    <base-modal v-model="showAllSpecialties" :title="$t('our-specialties')">
      <b-row>
        <b-col cols="12" sm="3" :offset-sm="calculateOffsetItemInModal(item)" v-for="item in items" :key="item"
          class="text-left">
          <img src="/static-appopensalud/img/icons/morillas-svg-icons/primary/tick-rounded.svg" class="mr-3" />
          {{ item }}
        </b-col>
      </b-row>
    </base-modal>
    <b-col md="12" lg="6" class="my-auto content">
      <h3>{{ $t('our-specialties') }}</h3>
      <div class="subtitle">
        <div class="subtitle-list mt-5">
          <b-row v-for="item in items.slice(0, 8)" :key="item" class="mb-3">
            <b-col cols="12">
              <span>
                <img src="/static-appopensalud/img/icons/morillas-svg-icons/primary/tick-rounded.svg"
                  class="mr-3" />{{ item }}
              </span>
            </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <base-button outline shadow @click="showAllSpecialties = true">{{ $t('see-all-specialties') }}</base-button>
    </b-col>
    <b-col md="12" lg="6" class="py-sm-0 py-lg-5 pl-lg-5">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
  </b-row>
</div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue'
import { sortBy } from 'lodash'

let messages = {
  es: {
    'our-specialties': 'Nuestras especialidades',
    'item1': 'Familia/Divorcios',
    'item2': 'Penal/Delitos',
    'item3': 'Laboral',
    'item4': 'Bancario',
    'item5': 'Civil',
    'item6': 'Herencias',
    'item7': 'Mercantil',
    'item8': 'Consumo',
    'item9': 'Vivienda',
    'item10': 'Impagos',
    'item11': 'Fiscal',
    'item12': 'Seguros',
    'item13': 'Multas y sanciones',
    'item14': 'Contratación',
    'item15': 'Internet',
    'item16': 'Seguridad social',
    'see-all-specialties': 'Ver todas las especialidades'
  },
  en: {
    'our-specialties': 'Our specialties',
    'item1': 'Family/Divorces',
    'item2': 'Criminal',
    'item3': 'Labor',
    'item4': 'Banking',
    'item5': 'Civil',
    'item6': 'Heritage',
    'item7': 'Merchant',
    'item8': 'Consumption',
    'item9': 'Housing',
    'item10': 'Unpaid',
    'item11': 'Fiscal',
    'item12': 'Insurance',
    'item13': 'Traffic fines and sanctions',
    'item14': 'Contract',
    'item15': 'Internet',
    'item16': 'Social security',
    'see-all-specialties': 'See all specialties'
  }
}

export default {
  components: {
    BaseModal
  },
  i18n: {
    messages
  },
  data () {
    const items = [ this.$t('item1'), this.$t('item2'), this.$t('item3'), this.$t('item4'), this.$t('item5'), this.$t('item6'), this.$t('item7'), this.$t('item8'), this.$t('item9'), this.$t('item10'), this.$t('item11'), this.$t('item12'), this.$t('item13'), this.$t('item14'), this.$t('item15'), this.$t('item16') ]
    return {
      showAllSpecialties: false,
      items: sortBy(items)
    }
  },
  methods: {
    calculateOffsetItemInModal (item) {
      if (this.items.indexOf(item) % 3 === 0) {
        return 2
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss">
#specialties {
  .col-bg {
    background-blend-mode: overlay;
    background-image: url('/static-appopensalud/img/bgs/texture.jpg'), linear-gradient(to bottom, $body-bg, transparent), linear-gradient(to top, transparent, $body-bg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalSpecialties.vue